import React, { useMemo, useEffect } from "react";
import { Stack, Box, Typography } from "@mui/material";
import useResponsive from "../../hooks/useResponsive";
import Header from "../../layout/dashboard/header";
import { useQuery } from "@tanstack/react-query";
import { useNotificationService } from "../../components/notification";
import { apiGetApplicantsById } from "../../api/application";
import { getUrlPathId } from "../../utils/url-id";
import { useLocation } from "react-router-dom";
import {
  CandidateDetailsData,
  CandidateDetailsProps,
} from "../../interface/application";
import CandidateContent from "../../components/jobBoard/CandidateContent";
import BackButton from "../../components/UIElements/BackButton";

const Candidate = () => {
  const isMedium = useResponsive("down", "md", "xl");
  const { showNotification } = useNotificationService();
  const location = useLocation();
  const applicantId = getUrlPathId(location?.pathname);

  const { data, error, isLoading, isError } = useQuery({
    queryKey: ["applicantDetails", applicantId],
    queryFn: () =>
      apiGetApplicantsById({
        applicantId: applicantId ?? "",
      }),
    enabled: !!applicantId,
    staleTime: 5 * 60 * 1000,
    retry: 1, // Only retry once to avoid multiple error notifications
  });

  useEffect(() => {
    // Only show error notifications if not loading and actually has error
    if (!isLoading && isError) {
      showNotification("Fetch process failed", "error");
      return;
    }

    // Only process error data if not loading
    if (!isLoading && data && data.status === "error" && "msg" in data) {
      showNotification(data.msg ?? "", "error");
    }
  }, [data, isError, isLoading, showNotification]);

  // FIX: Remove showNotification from useMemo
  const applicant_details: CandidateDetailsProps = useMemo(() => {
    if (isError || !data || data.status === "error") {
      return CandidateDetailsData;
    }
    return data?.data?.data ?? CandidateDetailsData;
  }, [data, isError]); // Removed showNotification from dependencies

  return (
    <>
      {/* Header Menu */}
      <Header>
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            justifyContent: "space-between",
            alignItems: "center",
            marginRight: "1rem",
            height: isMedium ? 60 : 75,
          }}
        >
          <Stack direction={"row"} alignItems={"center"} sx={{ gap: "10px" }}>
            <BackButton />
            <Typography
              variant={"subtitle1"}
              sx={{
                fontWeight: 500,
                fontFamily: "Lexend",
                color: "#2F66F4",
              }}
            >
              Candidate
            </Typography>
          </Stack>
        </Box>
      </Header>
      <CandidateContent candidate_info={applicant_details} />
    </>
  );
};

export default Candidate;
